import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { Button } from 'components/Button/Button'
import InputCard from 'components/Form/InputCard/InputCard'
import { addToast } from 'components/Toast/Toast'
import { SwitchButton } from 'components-ref/atoms'
import { useModalContext } from 'context/modalContext'
import { editMediaCategories } from 'services/endpoints/mediaCategory'
import './_edit-category-modal.scss'

interface Props {
    selectedCategory: { name: string; id: string | null ; public: number | null }
    closeDrawer: () => void
}

export const EditCategoryModal = ({ selectedCategory, closeDrawer }: Props) => {
    const [categoryName, setCategoryName] = useState(
        selectedCategory.name || ''
    )
    const [isPublic, setIsPublic] = useState(selectedCategory.public === 0)
    const modalData = useModalContext()
    const queryClient = useQueryClient()
    const { t } = useTranslation()
    const editCategory = useMutation(
        async () =>
            await editMediaCategories(categoryName, selectedCategory.id, isPublic),
        {
            onSuccess: () => {
                modalData.clearModal()
                closeDrawer()
                queryClient.invalidateQueries('allMediaCategories')
            },
            onError: () => {
                addToast('error', t('error:anErrorOccuredPleaseTryAgain'))
                modalData.clearModal()
                closeDrawer()
                queryClient.invalidateQueries('allMediaCategories')
            }
        }
    )

    const editCategorySubmit = () => {
        if (categoryName.trim() !== '') {
            editCategory.mutate()
        } else {
            addToast('error', t('error:pleaseInputCategoryName'))
        }
    }

    return (
        <div>
              <div style={{ display: 'flex', alignItems: 'center' , justifyContent: 'end', margin: '-45px 40px 10px 0px', gap: '5px' }}>
                            <SwitchButton active={isPublic} toggle={() => setIsPublic(!isPublic)} />
                            <span className="ml-2">{isPublic ? "Public" : "Private"}</span>
               </div>
            <InputCard
                customClass='edit-category-modal-input'
                hasDesc={true}
                desc={`${categoryName.trim().length} / 30 characters`}
                type='text'
                label={t('categoryName')}
                maxChars={30}
                value={categoryName}
                changeFn={(value: string) => {
                    setCategoryName(value)
                }}
            />
            <div className='edit-category-modal-buttons-container'>
                <Button
                    text={t('back')}
                    color='black'
                    clickFn={() => {
                        modalData.clearModal()
                        setCategoryName('')
                    }}
                    height='3'
                    width='13'
                    font='mont-14-normal'
                />
                <Button
                    text={t('save')}
                    color='blue'
                    customClass={`edit-category-modal-button ${
                        editCategory.isLoading
                            ? 'edit-category-modal-button-loading'
                            : ''
                    }`}
                    clickFn={editCategorySubmit}
                    height='3'
                    width='13'
                    font='mont-14-normal'
                />
            </div>
        </div>
    )
}
